export class Funding {
  constructor() {
    if(document.querySelector('#funding .accordion_selector select')) {
      document.querySelector('#funding .accordion_selector select').onchange = function() {
        let el = document.querySelector('#funding .accordion_selector select');

        let selected = el.value;

        document.querySelectorAll('#funding .accordion .option').forEach(function(el) {
          el.classList.remove('open');
        });

        document.querySelectorAll('#funding .accordion .option').forEach(function(el) {
          if(el.getAttribute('data-tab') == selected) {
            el.classList.add('open');
          }
        });

      }.bind(this)
    }
  }
}
